<div class="d-flex ps-1 w-100">
  @if (readonly() === false) {
    <portal-icon-button
      [class]="{
        'me-1': buttonPlacement() === 'left',
        'order-0': buttonPlacement() === 'left',
        'order-2': buttonPlacement() === 'right',
      }"
      [iconClass]="icon()"
      (onClick)="callback()(element())"
      buttonClass="btn btn-outline-secondary me-1"
    ></portal-icon-button>
  }

  <div
    class="flex-grow-1 order-1 d-flex align-items-center"
    [class]="{ 'fw-bold': highlight(), 'text-primary': highlight() }"
  >
    <ng-container
      *ngTemplateOutlet="
        elementTemplate() !== undefined ? elementTemplate() : defaultElementTemplate;
        context: { $implicit: element() }
      "
    ></ng-container>
  </div>
</div>
<ng-template #defaultElementTemplate let-item>
  <i class="far fa-exclamation-triangle"></i>
  <span>elementTemplate is not defined</span>
</ng-template>
